// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3lkHyv41qsDxGPo2RpqZQ8"};